import BaseListagem, { BaseListagemRef } from "components/BaseListagem";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Usuario from "model/administracao/cadastro/Usuario";
import HelpdeskTipoChamado from "model/helpdesk/HelpdeskTipoChamado";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useRef, useState } from "react";
import HelpdeskChamadoService from "service/helpdesk/HelpdeskChamadoService";
import { converterData, converterDataHora } from "utils/convert";
import { DateMatchModeOptions, dateRangeFilterTemplate, dropdownFilterTemplate, filterApplyTemplate, IdMatchModeOptions, ListMatchModeOptions, statusFilterTemplate, TextMatchModeOptions } from "utils/filterUtils";
import HelpdeskTramiteCadastroModal from "../helpdeskTramite/HelpdeskTramiteCadastroModal";
import { Dialog } from "@mui/material";
import HelpdeskGerarChamadoModal from "./HelpdeskGerarChamadoModal";

const helpdeskChamadoService = new HelpdeskChamadoService();

export default function HelpdeskChamadoListagem() {

    const [clientes, setClientes] = useState<Pessoa[]>([]);
    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [tiposChamado, setTiposChamado] = useState<HelpdeskTipoChamado[]>([]);
    const [gerarChamadoModal, setGerarChamadoModal] = useState<boolean>(false);
    const baseListagemRef = useRef<BaseListagemRef>(null);

    useEffect(() => {
        helpdeskChamadoService.clientes().then((response) => {
            setClientes(response);
        }).catch((err) => {
            console.error(err);
        });
        helpdeskChamadoService.usuarios().then((response) => {
            setUsuarios(response);
        }).catch((err) => {
            console.error(err);
        });
        helpdeskChamadoService.tiposChamado().then((response) => {
            setTiposChamado(response);
        }).catch((err) => {
            console.error(err);
        });
    }, []);

    const defaultFilters: DataTableFilterMeta = {
        dataCriacao: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        cliente: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        solicitante: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS,
                }
            ],
            operator: FilterOperator.AND
        },
        status: {
            constraints: [
                {
                    value: ["AA", "AC"],
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
        tipoChamado: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        prioridade: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
        descricao: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS,
                }
            ],
            operator: FilterOperator.AND
        },
        usuarioAtendente: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    const botoesExtra = () => {
        return [<Button key="btn2" label="Gerar Chamado"
            onClick={() => {
                setGerarChamadoModal(true)
                console.log(gerarChamadoModal)
            }} icon="pi pi-plus" style={{ marginRight: '8px' }} />]
    }

    const tipoChamadoFilterTemplate = (options: ColumnFilterElementTemplateOptions, itens: Array<any>, optionLabel = "descricao", optionValue = "id") => {
        return <Dropdown value={options.value} options={itens}
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel={optionLabel} optionValue={optionValue} placeholder="Qualquer" className="p-column-filter" />
    }

    return (
        <>
            <HelpdeskGerarChamadoModal
                visible={gerarChamadoModal}
                setVisible={setGerarChamadoModal}
                onConfirm={() => {
                    baseListagemRef.current?.reload();
                }}
            />
            <BaseListagem ref={baseListagemRef} ordenacao="dataCriacao,DESC" buttonsExtra={botoesExtra()} service={helpdeskChamadoService} showNewButton={false} urlService="/helpdeskChamado" tituloPagina={'Chamado do Helpdesk'} defaultFilters={defaultFilters} showClearFilterButton nome="helpdeskChamado" >
                <Column field="dataCriacao" header="Data de Criação" body={(rowData) => converterDataHora(rowData.dataCriacao)} style={{ width: '10%' }}
                    filter showFilterOperator={false} showAddButton={false} filterMatchModeOptions={DateMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={dateRangeFilterTemplate} filterMenuStyle={{ zIndex: 50 }} />
                <Column field="cliente.nome" header="Cliente" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate}
                    filterField="cliente"
                    filterElement={(options) => dropdownFilterTemplate(options, clientes)} />
                <Column field="solicitante" header="Solicitante"
                    body={(rowData) => rowData.usuarioCliente?.nome || rowData.nomeSolicitante}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
                <Column field="status" header="Status" body={(rowData) => helpdeskChamadoService.getStatus(rowData.status)}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={(options) => statusFilterTemplate(options, helpdeskChamadoService.getListaStatusFilter())}
                />
                <Column field="tipoChamado.descricao" header="Tipo de Chamado" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate}
                    filterField="tipoChamado"
                    filterElement={(options) => tipoChamadoFilterTemplate(options, tiposChamado)} />
                <Column field="prioridade" header="Prioridade" body={(rowData) => helpdeskChamadoService.getPrioridade(rowData.prioridade)}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={(options) => statusFilterTemplate(options, helpdeskChamadoService.getListaPrioridadeFilter())}
                />
                <Column field="descricao" header="Descrição" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    body={(rowData) => (
                        <div style={{ maxWidth: '150rem', whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                            {rowData.descricao}
                        </div>
                    )}
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
                <Column field="usuarioAtendente.nome" header="Responsável" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate}
                    filterField="usuarioAtendente"
                    filterElement={(options) => dropdownFilterTemplate(options, usuarios)} />
            </BaseListagem>
        </>
    )
}